import { createSlice } from '@reduxjs/toolkit';
import { resetApplication } from '../application/slice';
import { errorReceiveSiteLockers, failedReceiveSiteLockers } from '../lockers/slice';
import inventoryState from './state';
export const inventorySlice = createSlice({
    extraReducers: builder => {
        builder.addCase(resetApplication, () => inventoryState).addCase(errorReceiveSiteLockers, state => {
            state.inventory = undefined;
            state.receivingInventory = false;
        }).addCase(failedReceiveSiteLockers, state => {
            state.inventory = undefined;
            state.receivingInventory = false;
        });
    },
    initialState: inventoryState,
    name: 'inventory',
    reducers: {
        errorReceiveCalculatedInventory: state => {
            state.inventory = undefined;
            state.receivingInventory = false;
        },
        failedReceiveCalculatedInventory: state => {
            state.inventory = undefined;
            state.receivingInventory = false;
        },
        receiveCalculatedInventory: {
            prepare: inventory => {
                return {
                    payload: {
                        inventory
                    }
                };
            },
            reducer: (state, action) => {
                const { inventory } = action.payload;
                state.inventory = inventory;
                state.receivingInventory = false;
            }
        },
        receiveInventory: state => {
            state.receivingInventory = true;
        },
        resetInventory: () => inventoryState
    }
});
export const { errorReceiveCalculatedInventory, failedReceiveCalculatedInventory, receiveCalculatedInventory, receiveInventory, resetInventory } = inventorySlice.actions;
export default inventorySlice.reducer;
